<div class="modal-header">
	<button type="button" class="close" data-dismiss="modal">×</button>
	<h4 class="modal-title">{{TR "Adresse"}}</h4>
</div>

<div class="modal-body">
	{{ERROR_ROW errors.error}}
	<form>
	<div class="row">
		{{#if canView.addr_street}}
		<div class="col-sm-6">
			<div class="form-group">
				<label for="address-street" class="control-label">{{TR "Straße"}}</label>
				<input id="address-street" class="form-control {{#if errors.street}}parsley-error{{/if}}" name="street" type="text" value="{{ formData.street }}" placeholder={{TR "Straße"}}>
				{{#if errors.street}}
				<ul class="parsley-errors-list filled" id="js-street-error">
					<li class="parsley-required">{{TR "Straße ist"}} {{TR errors.street}}</li>
				</ul>
				{{/if}}
			</div>
		</div>
		{{/if}}
		{{#if canView.addr_number}}
		<div class="col-sm-6">
			<div class="form-group">
				<label for="address-number" class="control-label">{{TR "Hausnummer"}}</label>
				<input id="address-number" class="form-control {{#if errors.number}}parsley-error{{/if}}" name="number" type="text" value="{{ formData.number }}" placeholder={{TR "Hausnummer"}}>
				{{#if errors.number}}
				<ul class="parsley-errors-list filled" id="js-number-error">
					<li class="parsley-required">{{TR "Hausnummer ist"}} {{TR errors.number}}</li>
				</ul>
				{{/if}}
			</div>
		</div>
		{{/if}}
	</div>
	<div class="row">
		{{#if canView.addr_code}}
		<div class="col-sm-6">
			<div class="form-group">
				<label for="address-code" class="control-label">{{TR "PLZ"}}</label>
				<input id="address-code" class="form-control {{#if errors.code}}parsley-error{{/if}}" name="code" type="text" value="{{ formData.code }}" placeholder={{TR "PLZ"}}>
				{{#if errors.code}}
				<ul class="parsley-errors-list filled" id="js-code-error">
					<li class="parsley-required">{{TR "PLZ ist"}} {{TR errors.code}}</li>
				</ul>
				{{/if}}
			</div>
		</div>
		{{/if}}
		{{#if canView.addr_city}}
		<div class="col-sm-6">
			<div class="form-group">
				<label for="address-city" class="control-label">{{TR "Stadt"}}</label>
				<input id="address-city" class="form-control {{#if errors.city}}parsley-error{{/if}}" name="city" type="text" value="{{ formData.city }}" placeholder={{TR "Stadt" }}>
				{{#if errors.city}}
				<ul class="parsley-errors-list filled" id="js-city-error">
					<li class="parsley-required">{{TR "Stadtname ist"}} {{TR errors.city}}</li>
				</ul>
				{{/if}}
			</div>
		</div>
		{{/if}}
	</div>
	<div class="row">
		{{#if canView.addr_country}}
		<div class="col-sm-6">
			<div class="form-group">
				<label for="address-country" class="control-label">{{TR "Land"}}</label>
				<input id="address-country" class="form-control {{#if errors.country}}parsley-error{{/if}}" name="country" type="text" value="{{ formData.country }}" placeholder={{TR "Land"}}>
				{{#if errors.country}}
				<ul class="parsley-errors-list filled" id="js-country-error">
					<li class="parsley-required">{{TR "Land ist"}} {{TR errors.country}}</li>
				</ul>
				{{/if}}
			</div>
		</div>
		{{/if}}
	</div>
	{{#if canView.addr_street}}
	{{#if canView.addr_number}}
	{{#if canView.addr_code}}
	{{#if canView.addr_city}}
	{{#if canView.addr_country}}
	<div class="row m-t-20">
		<div class="col-sm-6">
			<div class="form-group">
				<label for="device-location-lng" class="control-label">{{TR "Längengrad"}}</label>
				<input id="device-location-lng" class="form-control {{#if errors.location-lng}}parsley-error{{/if}}" name="location-lng" type="number" step="0.001" value="{{JSON_OBJVALUE formData.location 0}}" placeholder={{TR "Längengrad"}}>
				{{#if errors.location-lng}}
				<ul class="parsley-errors-list filled" id="js-location-lng-error">
					<li class="parsley-required">{{TR "Längengrad ist"}} {{TR errors.location-lng}}</li>
				</ul>
				{{/if}}
			</div>
		</div>
		<div class="col-sm-6">
			<div class="form-group">
				<label for="device-location-lat" class="control-label">{{TR "Breitengrad"}}</label>
				<input id="device-location-lat" class="form-control {{#if errors.location-lat}}parsley-error{{/if}}" name="location-lat" type="number" step="0.001" value="{{JSON_OBJVALUE formData.location 1}}" placeholder={{TR "Breitengrad"}}>
				{{#if errors.location-lat}}
				<ul class="parsley-errors-list filled" id="js-location-lat-error">
					<li class="parsley-required">{{TR "Breitengrad ist"}} {{TR errors.location-lat}}</li>
				</ul>
				{{/if}}
			</div>
		</div>
	</div>
	{{/if}}
	{{/if}}
	{{/if}}
	{{/if}}
	{{/if}}
	</form>
</div>

<div class="modal-footer">
	<button id="ct-cancel" type="button" class="btn btn-white js-cancel" data-dismiss="modal">
		{{TR "Abbrechen"}}
	</button>
	<button class="btn btn-primary js-submit" id="js-success">
		{{TR "Speichern"}}
	</button>
</div>
